export default "__VITE_ASSET__22c7f21c__"